import { useTranslation } from 'react-i18next';
import { useToasts } from 'react-toast-notifications';

export const useCustomToast = () => {
  const { addToast } = useToasts();
  const { t } = useTranslation();

  const successToast = (successText?: string) => {
    addToast(successText ? successText : t('Your updates are successfully saved'), {
      appearance: 'success',
      autoDismiss: true,
    });
  };

  const errorToast = (errorText?: string) => {
    addToast(errorText ? errorText : t('Something went wrong'), {
      appearance: 'error',
      autoDismiss: true,
    });
  };

  const infoToast = (infoText?: string) => {
    addToast(infoText ? infoText : t('Copied to clipboard!'), {
      appearance: 'info',
      autoDismiss: true,
    });
  };

  const warningToast = (infoText?: string) => {
    addToast(infoText ? infoText : t('Attention required'), {
      appearance: 'warning',
      autoDismiss: true,
    });
  };

  return { successToast, errorToast, infoToast, warningToast };
};
